var SAFE_AREA_STYLE = {
  paddingTop: 'calc(env(safe-area-inset-top, 0px) + 4px)',
  paddingLeft: 'env(safe-area-inset-left, 0px)',
  paddingRight: 'env(safe-area-inset-right, 0px)'
};
var HEADER_CONTAINER_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  pb: '4',
  // need verify with designer
  zIndex: 1,
  backdropFilter: 'blur(8px)'
};
var HEADER_CONTAINER_CUSTOM_STYLES = {
  backgroundColor: 'rgba(255, 255, 255, 0.96)',
  boxShadow: '0px 1px 3px 0px var(--shadow-shadow-s, rgba(13, 17, 24, 0.08))'
};

export { HEADER_CONTAINER_CUSTOM_STYLES, HEADER_CONTAINER_STYLES, SAFE_AREA_STYLE };
//# sourceMappingURL=constants.js.map
